import { useTranslation } from 'react-i18next';
import { HeroRechargeCard } from './Hero';

const FREE_RECHARGE_RATIO = 10;

const EXAMPLE_COMPLETED = FREE_RECHARGE_RATIO - 1;

export default function FreeRechargeSection() {
  const { t } = useTranslation();

  const dots = Array.from({ length: FREE_RECHARGE_RATIO + 1 }, (_, i) => {
    if (i < EXAMPLE_COMPLETED) return 'completed';
    if (i === EXAMPLE_COMPLETED) return 'star';
    return 'pending';
  });

  return (
    <section className="bg-[#e8f4f3] py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">

          {/* Left: content */}
          <div className="flex-1 max-w-xl">
            {/* Badge */}
            <div className="inline-block bg-[#F5E9C9] text-[#B07D10] text-xs font-semibold px-3 py-1 rounded-full mb-5 uppercase tracking-wide">
              {t('freeRecharge.badge')}
            </div>

            {/* Title */}
            <h2 className="text-3xl lg:text-4xl font-brave-hunter text-[#187672] leading-tight mb-6">
              {t('freeRecharge.title', { ratio: FREE_RECHARGE_RATIO })}
            </h2>

            {/* Progress dots */}
            <div className="flex flex-wrap gap-2 mb-2 items-center">
              {dots.map((type, i) => (
                <div
                  key={i}
                  className={`rounded-full flex items-center justify-center flex-shrink-0 ${
                    type === 'completed'
                      ? 'bg-[#D9A520] w-6 h-6 '
                      : type === 'star'
                      ? 'bg-[#D9A520] w-8 h-8 ring-2 ring-[#D9A520] ring-offset-2 ring-offset-[#e8f4f3]'
                      : 'bg-[#187672] w-6 h-6 '
                  }`}
                >
                  {type === 'star' && (
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  )}
                </div>
              ))}
            </div>

            {/* Dots label */}
            <p className="text-sm text-gray-500 mb-6">
              {t('freeRecharge.dotsLabel', {
                completed: FREE_RECHARGE_RATIO,
                ratio: FREE_RECHARGE_RATIO,
                remaining: FREE_RECHARGE_RATIO - EXAMPLE_COMPLETED,
              })}
            </p>

            {/* Description */}
            <p className="text-base lg:text-lg text-gray-600 mb-8 leading-relaxed">
              {t('freeRecharge.description', { ratio: FREE_RECHARGE_RATIO })}
            </p>

            {/* Disclaimer */}
            <p className="text-xs text-gray-500">
              {t('freeRecharge.disclaimer')}
            </p>
          </div>

          {/* Right: recharge card */}
          <div className="w-full lg:w-[420px] xl:w-[480px]">
            <HeroRechargeCard
              className="rounded-3xloverflow-hidden"
              contentClassName="p-6"
            />
          </div>

        </div>
      </div>
    </section>
  );
}
